import { Component, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from '@mono-repo/util';

@Component({
  selector: 'app-bad-connection',
  templateUrl: './bad-connection.component.html',
  styleUrls: ['./bad-connection.component.scss'],
})
export class BadConnectionComponent {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  constructor(
    private router: Router,
    private utilityService: UtilityService,
  ) {}

  public retry(): void {
    this.router.navigateByUrl(this.utilityService.getSourceUrl());
  }
}
